import { useCallback, memo } from "react";

import cc from "classcat";
import { useLocalization } from "@fluent/react";
import { Button, MenuButton } from "@narmi/design_system";
import { useFeature } from "byzantine";

import usePathname from "../../../../components/hooks/usePathname";
import { useIsSidebarEnabled, useSidebarContainer } from "../sidebar.hooks";
import SearchBar from "../../search/SearchBar";

import styles from "./SidebarTop.module.scss";

const noop = () => {};

const SidebarTop = () => {
  const { isSidebarEnabled } = useIsSidebarEnabled();
  const { isCollapsed } = useSidebarContainer();
  const isSidebarExpanded = isSidebarEnabled && !isCollapsed;
  const { l10n } = useLocalization();
  const { featureEnabled } = useFeature();
  const pathname = usePathname();
  const hideTransferButton =
    featureEnabled("invoice_pay") && pathname.startsWith("/transfer/invoice");

  const handleTransferClick = useCallback(() => {
    window.location.assign("/transfer/");
  }, []);

  const handleSupportClick = useCallback(() => {
    window.location.assign("/support");
  }, []);

  const handleSettingsClick = useCallback(() => {
    window.location.assign("/settings");
  }, []);

  const handleLogoutClick = useCallback(() => {
    window.location.assign("/logout");
  }, []);

  if (!isSidebarEnabled) {
    return null;
  }

  const supportLabel = l10n.getString("sidebar-support");
  const settingsLabel = l10n.getString("topnav-settings");
  const logoutLabel = l10n.getString("topnav-logout");

  return (
    <div
      className={cc([
        styles.topRow,
        { [styles.sidebarExpanded]: isSidebarExpanded },
      ])}
    >
      <div className={styles.content}>
        <SearchBar />
        <div className={styles.actions}>
          {featureEnabled("transfers") && !hideTransferButton && (
            <Button
              size="m"
              label={l10n.getString("button-transfer")}
              onClick={handleTransferClick}
            />
          )}
          <div className={styles.iconButtons}>
            <button
              type="button"
              className={`${styles.iconCircle} button--reset`}
              aria-label={supportLabel}
              title={supportLabel}
              onClick={handleSupportClick}
            >
              <span aria-hidden="true" className="narmi-icon-life-buoy" />
            </button>
            <button
              type="button"
              className={`${styles.iconCircle} button--reset`}
              aria-label={settingsLabel}
              title={settingsLabel}
              onClick={handleSettingsClick}
            >
              <span aria-hidden="true" className="narmi-icon-settings" />
            </button>
            <div className={styles.logoutMenuButton} title={logoutLabel}>
              <MenuButton
                label={logoutLabel}
                triggerIcon="log-out"
                side="bottom"
              >
                <MenuButton.Item
                  label={l10n.getString("button-cancel")}
                  onSelect={noop}
                />
                <MenuButton.Item
                  label={l10n.getString("sidebar-logout-confirm")}
                  startIcon="log-out"
                  onSelect={handleLogoutClick}
                />
              </MenuButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SidebarTop.displayName = "SidebarTop";

export default memo(SidebarTop);
